/**
 * Google Drive's marks as icon components, one per kind, for a slot that takes
 * an icon component rather than an element (a list row's tile). Stable across
 * renders, so a row keeps its tile. The glyphs live in `google-drive-mark.tsx`.
 */
import type { ComponentType } from "react";

import type { GoogleDriveMarkKind } from "@/lib/google-drive-labels";

import {
  GoogleDriveDocMark,
  GoogleDriveFileMark,
  GoogleDrivePdfMark,
  GoogleDriveSheetMark,
  GoogleDriveSlidesMark,
} from "./google-drive-mark";

export const GOOGLE_DRIVE_MARK_ICONS: Readonly<Record<GoogleDriveMarkKind, ComponentType<{ className?: string }>>> = {
  doc: GoogleDriveDocMark,
  sheet: GoogleDriveSheetMark,
  slides: GoogleDriveSlidesMark,
  pdf: GoogleDrivePdfMark,
  drive: GoogleDriveFileMark,
};
